export interface AppConfig {
  readonly oidcAuthority: string;
  readonly oidcClientId: string;
  readonly apiHost: string;
  readonly amplitudeApiKey: string;
  /**
   * Base URL of the Toptracer Go client.
   *
   * Used to build brand preview links that open the real Go client with
   * `?brand=draft`. Environment-specific: pointing a dev admin at the
   * production client would preview the wrong site's branding.
   */
  readonly appHost: string;
  /**
   * MapLibre style URL for the site map. Optional: when absent the site map uses the
   * OpenFreeMap Positron style, so a tile provider can be swapped without code changes.
   */
  readonly mapStyleUrl?: string;
}

let cachedConfig: AppConfig | null = null;

export async function loadAppConfig(): Promise<AppConfig> {
  if (cachedConfig) {
    return cachedConfig;
  }

  const response = await fetch('/config.json');
  if (!response.ok) {
    throw new Error(`Failed to load config: ${response.status}`);
  }

  cachedConfig = await response.json();
  return cachedConfig!;
}

export function getAppConfig(): AppConfig {
  if (!cachedConfig) {
    throw new Error('Config not loaded. Call loadAppConfig() first.');
  }
  return cachedConfig;
}
